<template>
  <div @click="triggerEvent" class="header-feature-item">
    <i :class="icon"></i>
<!--    <p>{{title}}</p>-->
  </div>
</template>

<script>
export default {
    props:{
        icon:{
            type:String
        },
        title:{
            type:String
        }
    },
    methods:{
        triggerEvent(){
            this.$emit('click')
        }
    }
};
</script>

<style lang="scss" scoped >
.header-feature-item {
  /*height: 60px;*/
  /*width: 60px;*/
  display: flex;
  justify-content: center;
  // display: flex;
  // justify-content: center;
  text-align: center;
  flex-direction: column;
  color: #CCCCCC;
  border: 1px solid #ccc;
  &:hover{
      background: #dddddd;
      cursor: pointer;
      color: #0178ec;
  }
  & i{
    //   height: 15px;
    font-size: 19px;
    line-height: 20px;
  }
  & p{
      height: 20px;
      line-height: 20px;
    //   line-height: initial;
  }

}
</style>
